import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import FilterMenu from './FilterMenu';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

type CurrentMenuType = 'categories' | 'filters' | 'sorting';

const FilterBarButtons = () => {
  const [currentMenu, setCurrentMenu] = useState<
    CurrentMenuType | undefined
  >();
  const { subNavigation } = useTypedSelector(
    (state) => state.productFiltering
  );
  const [ready, setReady] = useState(false);

  useEffect(() => setReady(true), []);

  let currentCategory = subNavigation;
  let subCategories = subNavigation.links;
  while (currentCategory.links.length > 0) {
    subCategories = currentCategory.links;
    let foundCategory = currentCategory.links.find(
      (l) => l.isSelected == true
    );
    if (!foundCategory) {
      break;
    } else {
      currentCategory = foundCategory;
    }
  }

  return (
    <>
      <div className="lg:hidden flex gap-1 py-2 pb-4">
        <button
          className="btn btn--medium btn--black flex-1 text-white rounded-none"
          onClick={() => setCurrentMenu('filters')}
        >
          <Icon name="filter" className="text-[20px] leading-[24px]" />
          {translate('filter.filter')}
        </button>
        <button
          className="btn btn--medium btn--black flex-1 text-white rounded-none"
          onClick={() => setCurrentMenu('sorting')}
        >
          <Icon name="sort" className="text-[20px] leading-[24px]" />
          {translate('filter.sort')}
        </button>
      </div>

      {ready && (
        <FilterMenu
          currentMenu={currentMenu}
          setCurrentMenu={setCurrentMenu}
        />
      )}
    </>
  );
};

export default FilterBarButtons;
